import { render, staticRenderFns } from "./AlertHistory.vue?vue&type=template&id=c3dd6938&scoped=true"
import script from "./AlertHistory.vue?vue&type=script&lang=js"
export * from "./AlertHistory.vue?vue&type=script&lang=js"
import style0 from "./AlertHistory.vue?vue&type=style&index=0&id=c3dd6938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dd6938",
  null
  
)

export default component.exports